import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    error: 'Error',
  },
};
